module.exports = __webpack_public_path__ + "img/france-infectious-diseases-male.ff97fe4f.png";